const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

'use strict';
const Fancybox = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	classPopupHead: '.js-popup-head',
	classPopupHeadTrigger: '.js-popup-head-login-trigger',
	classPopupBid: '.js-popup-bid',
	//classPopupBidTrigger: '.js-popup-bid-trigger',

	/** @description Initialize */
	init: function() {
		//Log in
		this.fancyboxPopup('.js-popup-head-login-trigger', '.js-popup-head', 'login-popup');
		//this.fancyboxPopup('.js-popup-bid-trigger', '.js-popup-bid', 'bid-popup');
		// this.fancyboxPopup('.js-popup-proof-trigger', '.js-popup-proof', 'proof-popup');
		this.fancyboxPopup('.js-warning-trigger', '.js-warning', 'warning-popup');
		this.fancyboxPopup('.js-success-trigger', '.js-success', 'success-popup');
		this.fancyboxPopup('.js-registration-trigger', '.js-popup-registration', 'registration-popup');
		this.fancyboxPopup('.js-proof', '.js-popup-proof', 'proof-popup');
		this.fancyboxPopup('.js-popup-bid-trigger', '.js-popup-bid', 'bid-popup');
		//this.fancyboxPopup('.js-buy-now ', '.buynow-form_holder', 'bid-popup');
		this.fancyboxPopup('.js-watch-trigger', '.js-watch', 'watch-popup');
		this.fancyboxPopup('.js-highest-bidder', '.js-bidder', 'bidder-popup');
		//this.proofOfFundsPopup();
		this.closePopup();

		$('.js-close-watch').on('click', function(event){
			event.stopPropagation();
			$.fancybox.close({
				src: '.js-watch'
			});
		});

		// Buy now logic with login check
		$('.js-buy-now').on('click', function(event) {
			event.preventDefault();
			let isLoggedIn = $('#user-status').data('logged-in');
			if (isLoggedIn) {
				$.fancybox.open({
					src: '.buynow-form_holder',
					type: 'inline',
					opts: {
						touch: false
					}
				});
			} else {
				$('.site-header__login.js-popup-head-login-trigger').trigger('click');
			}
		});
	},

	/**
	 * @description Fancy box custom popup functionality.
	 * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
	 * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
	 * @param {string} trigger - popup trigger
	 * @param {string} popup - popup wrapper class
	 * @param {string} customClass - custom class for each popup (optional)
	 */
	fancyboxPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			touch: false,
			smallBtn: true,
			baseClass: customClass
		});
	},

	closePopup: () => {
		$('.js-close-popup-main').on('click', function(event){
			event.stopPropagation();
			$.fancybox.close();
		});
	},

	proofOfFundsPopup: () => {
		// when a button with js-proof class is clicked, on a single property page, a popup opens
		// TODO BE the url to which the button will lead should be changed (window.location.href)
		$('.js-proof').on('click', function(event){
			event.preventDefault();

			localStorage.setItem('jsProofClicked', 'true');

			window.location.href = '/fe-property-single';
		});

		if (window.location.pathname.indexOf('/fe-property-single') !== -1) {
			if (localStorage.getItem('jsProofClicked')) {
				localStorage.removeItem('jsProofClicked');
				$.fancybox.open({
					src: '.js-popup-proof',
					type: 'inline',
					touch: false,
					smallBtn: true,
					baseClass: 'proof-popup'
				});
			}
		}
	}
};

export default Fancybox;
